export default __webpack_public_path__ + "static/media/Tasset of Red Ruin.b9c178e4.jpg";